import { setQuizId, setQuizSet } from 'store/actions/Quiz'

import store from '../index'

const { dispatch } = store

export const dispatchSetQuizSet = payload => dispatch(setQuizSet(payload))
export const dispatchSetQuizId = payload => dispatch(setQuizId(payload))
